import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import serviceProviderSlice from './serviceProviderSlice';

export interface RevenueState {
  data: [] | null | any;
  vendorData: [] | null | any;
  totalPage: number | null;
  currentPage: number | null;
  totalRecords: number | null;

  dataParking: [] | null | any;
  vendorDataParking: [] | null | any;
  totalPageParking: number | null;
  currentPageParking: number | null;
  totalRecordsParking: number | null;
}

const initialState: RevenueState = {
  data: null,
  vendorData: null,
  totalPage: null,
  currentPage: null,
  totalRecords: null,

  dataParking: null,
  vendorDataParking: null,
  totalPageParking: null,
  currentPageParking: null,
  totalRecordsParking: null,
};

export const revenueSlice = createSlice({
  name: 'revenue',
  initialState,
  reducers: {
    setRevenue: (state, action) => {
      state.data = action.payload;
      state.vendorData = action.payload;
      state.totalPage = action.payload.totalPage;
      state.currentPage = action.payload.currentPage;
      state.totalRecords = action.payload.totalRecords;
    },
    reset: (state) => {
      state = initialState;
    },
    setRevenueParking: (state, action) => {
      state.dataParking = action.payload;
      state.vendorDataParking = action.payload;
      state.totalPageParking = action.payload.totalPage;
      state.currentPageParking = action.payload.currentPage;
      state.totalRecordsParking = action.payload.totalRecords;
    },
  },
});

export const { setRevenue, reset, setRevenueParking } = revenueSlice.actions;
export const getRevenue = (state: RootState) => state.revenue.data;
export const getRevenueParking = (state: any) => state.revenue.dataParking;
export const getVendorRevenue = (state: RootState) => state.revenue.vendorData;
export const getRevenueTotalPages = (state: RootState) => state.revenue.totalPage;
export const getRevenueTotalRecord = (state: RootState) => state.revenue.totalRecords;
export const getRevenueTotalRecordParking = (state: RootState) => state.revenue.totalRecordsParking;

export default revenueSlice.reducer;
